import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {ArkInfoPanel} from "@/scenes.ui/ark-info-panel";

export class Monastery10InfoPanel extends Phaser.GameObjects.Container {

    public static readonly PANEL_HEIGHT = 60;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement) {
        super(scene);

        this.scene = scene;
        this.height = Monastery10InfoPanel.PANEL_HEIGHT;
        let self = this;

        let back = SpriteUtils.addImage(this.scene, -300, 0, Keys.OBLIVION_BACK_2, undefined).setOrigin(0, 0);

        let help1 = TextUtils.addTextAdvanced(scene, 'Все дары героев этой вкладки можно улучшить до 12 ранга (на ур. победы 20 000).', 0, 30,
            '#b8c2d7', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        const separator = SpriteUtils.addSprite(this.scene!, -300, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([back, help1, separator]);
    }

}
